export default "__VITE_ASSET__C0Iyo7xX__"